import type { Entry } from 'contentful';

import { getLocale, type Locale } from '@libs/core';

export const getTags = () => {
    const locale: Locale = getLocale();

    const tagsString: { [key: string]: string } = {
        'en-US': 'siteUs',
        'en-CA': 'siteCa',
    };

    return tagsString[locale];
};

export const filterEntryByTag = (entry: Entry): Entry | null => {
    // Check if that an instance of Entry to avoid parsing non-Entry objects
    if (entry?.metadata && entry?.sys && entry?.fields) {
        // Parse each field of the entry for nested entries
        Object.keys(entry.fields).forEach((entryFieldKey: string) => {
            let entryField = entry.fields[entryFieldKey];

            // If entryField is an object or an array, we need to deep parse it
            if (Array.isArray(entryField)) {
                entryField = entryField
                    .map(subEntry => filterEntryByTag(subEntry as Entry))
                    // Remove null values from the array
                    .filter(Boolean) as Entry[];
            } else if (typeof entryField === 'object' && entryField !== null) {
                entryField = filterEntryByTag(entryField as Entry);
            }

            // Update the entry field with the parsed value or return empty object for null values
            entry.fields[entryFieldKey] = entryField ?? {};
        });
    }

    // Check metadata for tags and apply following logic:
    // - if entry has a tag AND tag include current locale = return entry
    // - if entry has a tag AND tag does not include the current locale = return null
    // - if entry has no tags = return entry (since the entry should be shown to all locales by default)
    if (entry?.metadata?.tags) {
        const tags = entry.metadata.tags.map(tag => tag.sys.id);
        const shouldReturnEntry = tags.includes(getTags()) || tags.length === 0;

        if (!shouldReturnEntry) {
            return null;
        }
    }

    return entry;
};

export const filterEntriesByTag = <T extends Entry>(entries: T[]): T[] => {
    return entries.map((entry: T) => filterEntryByTag(entry)).filter(Boolean) as T[];
};
